import { AxiosPromise } from 'axios'
import { useAxiosClient } from './configs/axios-setup'

type HookState = { data: any; loading: boolean; error: unknown }

const manualOptions = { manual: true, autoCancel: false, useCache: false }

export const useGetStorageTestConfig = (): [HookState, () => AxiosPromise<any>] => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    { url: '/storage-test/config', method: 'GET' },
    manualOptions
  )
  return [{ data, loading, error }, () => doFetch()]
}

export const useStorageTestToken = (): [HookState, () => AxiosPromise<any>] => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    { url: '/storage-test/token', method: 'POST' },
    manualOptions
  )
  return [{ data, loading, error }, () => doFetch()]
}

export const useStorageTestList = (): [HookState, (prefix?: string) => AxiosPromise<any>] => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    { url: '/storage-test/list', method: 'GET' },
    manualOptions
  )
  const refetch = (prefix?: string) =>
    doFetch({
      url: prefix ? `/storage-test/list?prefix=${encodeURIComponent(prefix)}` : '/storage-test/list'
    })
  return [{ data, loading, error }, refetch]
}

export const useStorageTestUpload = (): [HookState, () => AxiosPromise<any>] => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    { url: '/storage-test/upload', method: 'POST' },
    manualOptions
  )
  return [{ data, loading, error }, () => doFetch()]
}
